/**
 * Picks v2 or v1 of the Media Resource create form based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import MediaResourceForm     from './MediaResourceForm';
import MediaResourceFormV2   from './v2/MediaResourceFormV2';

export default function MediaResourceFormSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? MediaResourceFormV2 : MediaResourceForm;
  return <Component {...props} />;
}
